<script lang="ts">
    import type { TWordpressFabricFooterTranslations } from '$lib/services/wordpress/types';
    export let translations: TWordpressFabricFooterTranslations;
    const links = translations.social_media_links || [];
</script>

<div class="flex justify-start gap-2xs tablet:justify-end">
    {#each links as link}
        {#if link.enabled === 'true'}
            <a
                href={link.link}
                class=" flex h-md w-md items-center justify-center rounded-full bg-grey-5"
            >
                <img src={link.icon} alt={link.link} />
            </a>
        {/if}
    {/each}
</div>
